/* TODO: This is duplicated code from the css file.
 *   See definitions in ./css/app.css
 */
const getDesignTokens = (mode => ({
  palette: {
    mode,
    primary: {
        main: mode === 'light' ? '#333' : '#fff'
    },
    secondary: {
        main: mode === 'light' ? '#000' : '#fff'
    },
    background: {
        default: mode === 'light' ? '#fff' : '#333'
    }
  }
}));

export default getDesignTokens;
